<template>
  <transition name="fade">
    <div class="nfDialogBox" v-show="isShow" @click.self="handleClickModal">
      <div class="content">
        <div class="exhibition" v-if="type == 'exhibition'">
          <div class="title">{{ info.name }}</div>
          <div class="mainIcon"></div>
          <div class="tips">展馆筹备中，敬请期待…</div>
        </div>
        <div class="appointment" v-if="type == 'appointment'">
          <div class="info-title">
            <img src="../../../../assets/images/icon_building.png" alt="" class="info-title-icon" />
            展馆名称
          </div>
          <div class="info-text">
            {{ info.name }}
          </div>
          <div class="info-title">
            <img src="../../../../assets/images/openHours.png" alt="" class="info-title-icon" />
            开放时间
          </div>
          <div class="info-text">
            {{ info.redTemplate.openingHours || "未知" }}
          </div>
          <div class="info-title">
            <img src="../../../../assets/images/location.png" alt="" class="info-title-icon" />
            展馆地址
          </div>
          <div class="info-text clickable" @click="gotoMap">
            {{ info.address.address }}
          </div>
          <div class="info-title">
            <img src="../../../../assets/images/tongxunlu.png" alt="" class="info-title-icon" />
            预约方式
          </div>
          <div class="info-text clickable" @click="makeCall">
            {{ info.redTemplate.fnModule.appointment.contact }}
          </div>
        </div>
        <i class="icon-close" @click.self="handleClose"></i>
      </div>
    </div>
  </transition>
</template>
<script>
import { jumpToAmap } from '@/utils/amap'

export default {
  name: 'NfDialog',
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'exhibition'
    },
    info: {
      type: Object,
      default: null
    }
  },
  methods: {
    handleClose () {
      this.$emit('update:isShow', false)
    },
    handleClickModal () {
      this.closeOnClickModal && this.handleClose()
    },
    gotoMap () {
      const latitude = this.info.address.point.x
      const longitude = this.info.address.point.y
      const address = this.info.address.address
      jumpToAmap(latitude, longitude, address)
    },
    makeCall () {
      if (this.info.redTemplate.fnModule.appointment && this.info.redTemplate.fnModule.appointment.contact) {
        window.location.href = `tel:${this.info.redTemplate.fnModule.appointment.contact}`
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.nfDialogBox {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.5);
  .content {
    position: relative;
    background-image: linear-gradient(180deg, #ff5837 0%, #b8301a 100%);
    .exhibition {
      width: 5.9rem;
      height: 7.64rem;
      box-sizing: border-box;
      padding: 0.3rem;
      position: relative;
      .title {
        font-size: 0.36rem;
        color: #ffdca3;
        text-align: center;
        margin-top: 1.36rem;
      }
      .mainIcon {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 1.5rem;
        height: 1rem;
        background: url("../../../../assets/images/icon_empty.png") no-repeat center center;
        background-size: cover;
      }
      .tips {
        font-size: 0.28rem;
        color: rgba(255, 255, 255, 0.46);
        position: absolute;
        top: 60%;
        left: 50%;
        width: 5.3rem;
        text-align: center;
        transform: translate(-50%, 0);
      }
    }
    .appointment {
      width: 5.9rem;
      padding: 0.5rem 0.4rem 0.73rem;
      box-sizing: border-box;
      .info-title {
        font-family: PingFang-SC-Bold;
        font-size: 0.3rem;
        line-height: 0.42rem;
        margin-top: 0.3rem;
        color: #ffdca3;
        display: flex;
        align-items: center;
        font-weight: bold;
        .info-title-icon {
          width: 0.3rem;
          height: 0.3rem;
          margin-right: 0.1rem;
        }
      }
      .info-text {
        padding-left: 0.42rem;
        margin-top: 0.1rem;
        font-family: PingFangSC-Regular;
        font-size: 0.28rem;
        line-height: 0.4rem;
        color: #ffffff;
      }
      .clickable {
        text-decoration: underline;
      }
    }
    .icon-close {
      background: url("../../../../assets/images/icon_delete.png") no-repeat center;
      background-size: 0.2rem 0.2rem;
      display: inline-block;
      height: 0.8rem;
      width: 0.8rem;
      position: absolute;
      top: 0;
      right: 0;
    }
  }
}
</style>
